const SectionDivider = ({onDark = false}: { onDark?: boolean }) => {
    return (
        <div className={`${onDark ? 'bg-dark-mode' : 'bg-ivory'} py-8`}>
            <div className={`border-t-2 ${onDark ? 'border-ivory/50' : 'border-royal-pine/50'}`}></div>
        </div>
    );
};

export default SectionDivider;